import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function GuideAchatProduits() {
  return <SEOArticlePage article={articleContents["guide-achat-produits"]} />;
}